<template>
  <div @click.stop class="dialog-content relative w-full border border-gray-200 bg-white p-8 shadow-xl max-w-[570px] rounded-xl">
    <button @click="$emit('close')" class="absolute top-8 right-8 text-gray-400 hover:text-gray-600 transition-colors focus:outline-none">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    <div class="flex flex-col text-left pr-6">
      <h2 class="text-xl font-bold leading-tight text-gray-900 mb-6 mt-1">Hapus Kategori Ini?</h2>
      <p class="text-[15px] text-gray-500 leading-relaxed">
        Kategori ini akan dihapus dari daftar. Tenang, semua produk di dalam kategori ini tidak akan terhapus dari toko Anda.
      </p>
    </div>
    <div class="mt-10 flex justify-between gap-4">
      <button @click="$emit('close')" class="inline-flex items-center justify-center rounded-[10px] text-sm transition-colors focus:outline-none bg-[#F3F4F6] font-medium text-gray-900 hover:bg-[#E5E7EB] h-[36px] w-[255px]">
        Batal
      </button>
      <button @click="$emit('submit', 'DELETE_CATEGORY')" class="inline-flex items-center justify-center rounded-[10px] text-sm transition-colors focus:outline-none bg-[#F95E16] text-white font-medium hover:bg-[#E65113] h-[36px] w-[255px]">
        Ya, Hapus
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteCategoryDialog'
}
</script>
